import apiUrl from '../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import DatePicker from 'vue2-datepicker'
import CryptoJS from 'crypto-js';
import moment from 'moment'
import {
	BasicSelect
} from 'vue-search-select';
import VueElementLoading from 'vue-element-loading';


export default {

	name: 'direct-to-bag',
	components: {
		Paginate,
		DatePicker,
		BasicSelect,
		VueElementLoading,
	},
	data: function() {
		return {
			isLoading: false,
			bayno:"",
			binno:"",
			invalidTokenModal: false,
			invalidtokenmsg: '',
			listData:[],
			displayList:false,
			binShipmentDetails:[],
			showBinShipmentDetails:false,
			hubName:'',
			removeShipmentConfirmationModel: false,
			binBarcode:'',
			binNumber:'',
			bayNumber:'',
			layoutNumber:'',
			shippingId:'',
			UpdateStatusModal:false,
			binLoading:false,
			pageCount :0,
            totalCount :0,
			pageno: 0,
	        limit: 10,
			layout:"",
			activelayout: false
		}
	},
	created: function() {},
	computed: {},
	filters: {
		moment: function(date) {
			if (date == null || date == '')
				return '--'
			return moment(date).format('DD-MM-YYYY HH:mm:ss');
		}
	},
	mounted() {
		var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.createdby = userdetail[0].email;
		this.hubId = userdetail[0].HubId[0];
		this.getActiveLayouts();
		this.getHubName(this.hubId)
	},
	methods: {
		
	
		showBinDetails(resetPage = false) {
			 if (resetPage) {
            this.pageno = 0;
		};
			this.isLoading = true;
			this.listData=[],
      axios({
          method: 'GET',
          'url': apiUrl.api_url_hubops + "getBinDetailsForAllBayForSorter?currentHubId="+ this.hubId + (this.layout?'&layoutNumber='+ this.layout:'')+ (this.bayno?'&bayNo='+ this.bayno:'')+ (this.binno?'&binNo='+this.binno:'')+'&pageNo=' +this.pageno + '&pageSize='+this.limit,
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
            'requestfrom': "WEB",
            'token': this.token
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
			            this.displayList=true
                        this.totalCount = result.data.ResponseData.totalCount;
						this.listData = result.data.ResponseData.data;
						if (this.totalCount < this.limit) {
							this.pageCount = 1 ;
				  		} else {
							this.pageCount = Math.ceil(this.totalCount / this.limit);
				  		}
						this.invalidTokenModal = false
          } else if (result.data.ResultCode == 401) {
						this.invalidTokenModal = true
						this.invalidtokenmsg = result.data.ReturnMessage
						this.$alertify.error(result.data.ReturnMessage)
          } else {
						this.displayList=false
						this.invalidTokenModal = false
                        this.$alertify.error(result.data.ReturnMessage)
          }
					this.isLoading = false;
        }, error => {
					this.isLoading = false;
          console.error(error)
        })
    },
		logout(e) {
			localStorage.removeItem('permissiondata')
			localStorage.removeItem('userdetail')
			localStorage.removeItem('userToken')
			localStorage.removeItem('isLoggedIn')
			localStorage.removeItem('loginDate')
			this.$router.push('/login')
			e.preventDefault()
		},
		closeinvalidTokenModal() {
			this.invalidTokenModal = false
			this.invalidtokenmsg = ''
		},
		resetForm() {
			this.isLoading = false;
			this.binno="";
			this.bayno="";
			this.displayList=false;
			this.listData = [];
			this.pageCount = 0;
            this.totalCount = 0;
			this.pageno = 0 ;
			this.layout = "",
			this.$validator.reset();
			this.errors.clear();
		},

		 getPaginationData(pageNum) {
  	 		this.pageno = (pageNum - 1) 
  	 		this.showBinDetails();
   },

		showBinShipmentDetail(currentHubId,binbarcode,binno,bayno,layoutno){
			this.isLoading = true;
			this.binShipmentDetails = []; 
			this.binBarcode = binbarcode;
			this.binNumber = binno;
			this.bayNumber = bayno;
			this.layoutNumber = layoutno;

			axios({
					method: 'GET',
					url: apiUrl.api_url_hubops + 'getBinShipmentDetails?binBarcode=' + binbarcode + '&currentHubId='+ currentHubId ,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25'
					}
				})
				.then(result => {
					if (result.data.ResultCode == 100) {
						
						this.binShipmentDetails = result.data.ResponseData
						this.showBinShipmentDetails=true;
					} else {
						this.$alertify.error(result.data.ReturnMessage);
						this.binShipmentDetails = []; 
					}
					this.isLoading = false;
				}, error => {
					this.isLoading = false;
					console.error(error)
				})
		},
		closeBinShipmentLog()
		{
			this.showBinShipmentDetails = false
			$(document.body).removeClass("modal-open");
			$(".modal-backdrop").remove();
		},
	getActiveLayouts() {
		this.isLoading = true;
      axios({
          method: 'GET',
          url: apiUrl.api_url_hubops +'getAllActiveLayoutsForHub?currentHubId=' + this.hubId + '&isActive='+ true + '&isConfigActive='+ true,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
			this.isLoading = false;
          if (result.data.ResultCode == 100) {
			this.activelayout = true;
          } else {
			this.activelayout = false;
          }
        }, error => {
			this.isLoading = false;
          console.error(error)
        })
    },

		getHubName(hubid) {
      this.CityId = 0
      this.input = {
        hubids: [hubid]
      }
      axios({
          method: 'POST',
          url: apiUrl.api_url_hubops + 'expose/hubservicecenter/hubarray/get',
          data: this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.hubName = result.data.ResponseData[0].HubName;
          } else {
            this.hubName = '';
          }
        }, error => {
          console.error(error)
        })
    },
		removeBinShipment(bayNo ,binBarcode, shippingId,layoutNo){
			this.isLoading = true;
			this.input = ({
				currentHubId: this.hubId,
      			currentHubName: this.hubName,
      			binBarcode: binBarcode,
      			bayNumber: bayNo,
				layoutNumber:layoutNo,
      			shippingId: shippingId,
				lastModifiedBy: this.createdby,
				statusMarkedFrom:'WEB'
			
			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url_hubops + 'deLinkAwb',
					'data': this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
					}
				})
				.then(async result => {
 				 if (result.data.ResultCode == 100) {

 					 await this.showBinShipmentDetail(this.hubId,binBarcode,this.binNumber, bayNo,layoutNo);
 					 this.$alertify.success(result.data.ReturnMessage);
					 await this.showBinDetails();
 				 } else {
 					 this.$alertify.error(result.data.ReturnMessage);
 				 }
				 this.isLoading = false;
				}, error => {
					this.isLoading = false;
					console.error(error)
				})
		},
		cancelRemoveShipment() {
			this.showBinShipmentDetail(this.hubId,this.binBarcode,this.binNumber,this.bayNumber,this.layoutNumber);
      		this.removeShipmentConfirmationModel = false
    },
    removeShipment(shippingid) {
			this.closeBinShipmentLog()
			this.shippingId = shippingid;
			this.removeShipmentConfirmationModel = true
    },


    continueRemoveShipment() {
      this.removeShipmentConfirmationModel = false
	  this.removeBinShipment(this.bayNumber , this.binBarcode,this.shippingId,this.layoutNumber);
    },


	openUpdateStatusModal(data) {
      this.binNumber = '';
	  this.binBarcode = '';
      this.UpdateStatusModal = true;
      this.binNumber = data.binNo;
	  this.binBarcode = data.binBarcode;
    },


    closeUpdateStatusModal() {
      this.UpdateStatusModal = false
    },


	deactivateBin() {
	  this.isLoading = true;
      this.input = {
		    binBarcode: this.binBarcode,
      		hubId: this.hubId,
      		hubName : this.hubName,
      		createdBy : this.createdby,
      		status : 4,
			statusMarkedFrom:'web'
      }
      axios({
          'method': 'POST',
          'url': apiUrl.api_url_hubops + 'resetBin',
          'data': this.input,
          'headers': {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.$alertify.success(result.data.ReturnMessage)
            this.closeUpdateStatusModal();
			this.showBinDetails();
            
          } else {
            this.$alertify.error(result.data.ReturnMessage)
          }
					this.isLoading = false;
        }, error => {
					this.isLoading = false;
          console.error(error)
        })
    },
	downloadCSV() {
        if (!this.totalCount || this.totalCount === 0) {
            this.$alertify.error('No data available to download');
            return;
        }

        this.isLoading = true;
        const pageSize = this.totalCount;
        const url = apiUrl.api_url_hubops +
            "getBinDetailsForAllBayForSorter?currentHubId=" + this.hubId +
            (this.layout ? '&layoutNumber=' + this.layout : '') +
            (this.bayno ? '&bayNo=' + this.bayno : '') +
            (this.binno ? '&binNo=' + this.binno : '') +
            '&pageNo=0&pageSize=' + pageSize;

        axios({
            method: 'GET',
            url: url,
            data: this.input,
            headers: {
                'authorization': 'authkey xB84JJ89Hd25',
                'requestfrom': 'WEB',
                'token': this.token
            }
        })
        .then(result => {
            if (!(result && result.data && result.data.ResultCode == 100)) {
                this.$alertify.error((result && result.data && result.data.ReturnMessage) || 'Failed to fetch data for download');
                return;
            }

            const serverData = result.data.ResponseData && result.data.ResponseData.data ? result.data.ResponseData.data : (result.data.ResponseData || []);
            if (!Array.isArray(serverData) || serverData.length === 0) {
                this.$alertify.error('No data available to download');
                return;
            }

            const headers = [
                'Bag Destination',
                ...(this.activelayout ? ['Layout No'] : []),
                'Bay No',
                'Bin No',
                'Bin Barcode',
                'Shipment Count',
                'Created Date',
                'Active Hours'
            ];

            const rows = serverData.map(item => [
                item.destinationHubName,
                ...(this.activelayout ? [item.layoutNumber] : []),
                item.bayNo,
                item.binNo,
                item.binBarcode,
                item.shipmentCount,
                moment(item.createdDate).format('DD-MM-YYYY HH:mm:ss'),
                item.activeDuration
            ]);

            const csvContent = [headers, ...rows].map(e => e.map(v => `"${v || ''}"`).join(',')).join('\n');
            const timestamp = moment().format('YYYY.MM.DD_HH.mm.ss');
            const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
            const link = document.createElement('a');
            const urlBlob = URL.createObjectURL(blob);
            link.setAttribute('href', urlBlob);
            link.setAttribute('download', `ActiveBinReport_${timestamp}.csv`);
            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(urlBlob);
        })
        .catch(error => {
            console.error('Download CSV error', error);
            this.$alertify.error('Error downloading CSV');
        })
        .finally(() => {
            this.isLoading = false;
        });
    }
	}
}



// WEBPACK FOOTER //
// ./src/views/components/DirectToBag/DirectToBag.js